import { render } from "./BaseSingleSpeciesGallery.vue?vue&type=template&id=a45e52aa"
import script from "./BaseSingleSpeciesGallery.vue?vue&type=script&lang=js"
export * from "./BaseSingleSpeciesGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__